import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import PlaceholderImage from "./PlaceholderImage";
import "./ProgramCard.css";

export default function ProgramCard({ program, index }) {
  const Icon = program.icon;
  return (
    <article className="program-card">
      <div className="program-card__media">
        {/* <PlaceholderImage tone={String((index % 5) + 1)} alt={`${program.title} training at Firm Fit Factory`} ratio="4/3" /> */}
        <img src={program.img} alt="" className="proimg" />
        <span className="program-card__intensity">{program.intensity}</span>
      </div>
      <div className="program-card__body">
        <div className="program-card__icon"><Icon aria-hidden="true" /></div>
        <h3 className="program-card__title">{program.title}</h3>
        <p className="program-card__desc">{program.shortDescription}</p>
        <Link to={`/programs#${program.id}`} className="program-card__link">
          View Program <FiArrowUpRight aria-hidden="true" />
        </Link>
      </div>
    </article>
  );
}
